import {TailSpin} from 'react-loader-spinner'
export const Component: React.FC = () => (
  <div className="flex items-center justify-center h-screen">
    <TailSpin
      color="#1E40AF"
      height={50}
      width={50}
    />
  </div>
);